import Yup from 'utils/validation';

export const selectTalentPoolSchema = Yup.object({
  talentPoolId: Yup.string().required('Please select a talent list')
});

export type SelectTalentPoolFormData = Yup.InferType<
  typeof selectTalentPoolSchema
>;
